const GET_HOME_BANNERS = {
  method: 'GET',
  url: '/banners?populate=*&filters=[active]=true',
}

export default GET_HOME_BANNERS
